var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.alert)?_c('div',{staticClass:"my-4"},[(_vm.offer)?_c('OfferStatus',{attrs:{"payload":_vm.offer,"buttonClass":"offer-status-button"}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }